<template>
  <modal :ignore-backdrop-click="true" :show.sync="shown" v-if="!!fromItem"
    modal-classes="order-modal modal-dialog-centered modal-dialog-scrollable"
    @onShowSubProductOptions="handleShowSubProductOptions" @onShowValueOptions="handleShowValueOptions"
    @close="clearSelectedItems">
    <template slot="header">
      <div class="media d-flex align-items-center">
        <div v-if="showSubProductOptions" class="clickable pr-1 text-lg"
          @click="onBackClick(selectedSubProduct.subProduct.options)">
          <i class="now-ui-icons k-icon-left-open"></i>
        </div>

        <div v-if="showValueOptions" class="clickable pr-1 text-lg"
          @click="onBackClick(selectedValueSubOptions.value.options, false)">
          <i class="now-ui-icons k-icon-left-open"></i>
        </div>

        <div class="title-up media-body font-weight-bold mb-1">
          {{
            showSubProductOptions
            ? selectedSubProduct.subProduct.name :
            (showValueOptions && selectedValueSubOptions && selectedValueSubOptions.value) ?
              selectedValueSubOptions.value.name
              : (editMode
                ? $t('text.editing_menu_choices')
                : $t('text.adding_menu_choices'))
          }}
        </div>
      </div>
    </template>
    <alert type="danger" v-if="showAlert">
      <div class="alert-icon">
        <i class="now-ui-icons k-icon-notifications"></i>
      </div>
      <strong>{{ $t("message.resource_error_notify_title") }}</strong>
      {{ msgAlert }}
    </alert>
    <div class="options" v-show="!showSubProductOptions && !showValueOptions">
      <cards class="shadow-none mb-2 menu-item" body-classes="p-0">
        <div class="p-1 menu-item media align-items-stretch">
          <div class="left-column">
            <el-image v-if="fromItem.image" class="image" :src="fromItem.image" fit="cover" />
            <div class="mr-2 clickable position-absolute favourite" :class="{ top: fromItem.image }">
              <favourite-selected v-if="fromItem.is_favourite" />
              <favourite-unselected v-if="!fromItem.is_favourite" />
            </div>
          </div>
          <div class="media-body d-flex flex-column">
            <h5 class="mb-2">{{ fromItem.name }}</h5>
            <p class="text-gray mb-1 description">
              {{ fromItem.description }}
            </p>
            <div>
              <div class="d-inline dietry-requirements" v-for="(dieatry, index) in getMenuItemDieatriesIcons(fromItem)"
                :key="index">
                <i class="new-ui-icons mr-1" :class="dieatry.icon" :title="dieatry.name"></i>
              </div>
            </div>
          </div>

          <div class="
                  price
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                ">
            <span class="text-sm mb-1 font-weight-bolder">
              {{ getItemPrice | currency(currentCurrency) }}
            </span>
            <el-button type="primary" icon="el-icon-minus" @click.prevent="decrease" :disabled="fromItem.quantity <= 1"
              round></el-button>
            <div class="py-1">{{ fromItem.quantity }}</div>
            <el-button type="primary" icon="el-icon-plus" @click.prevent="increase" :disabled="fromItem.quantity >= 999"
              round></el-button>
          </div>
        </div>
      </cards>
      <hr class="m-0" />
      <!---- Start Meal Deal Sections ---->
      <slot ref="itemMealDealSections" name="item-meal-deal-sections"
        v-if="fromItem.sections && fromItem.sections.length"></slot>
      <!---- End Meal Deal Sections ---->
      
      <!---- Start Options ---->
      <slot name="item-options"></slot>
      <!---- End Options ---->

      <!---- Start Comment ---->
      <div class="mt-4">
        <span class="font-weight-bold">{{ $t("text.add_comment") }}</span>
        <fg-textarea maxlength="500" class="no-border" :placeholder="$t('input.placeholder.your_comment')"
          addon-left-icon="now-ui-icons k-icon-comment" v-model="fromItem.comment"></fg-textarea>
      </div>
      <!---- End Comment ---->
    </div>
    <div v-if="showSubProductOptions">
      <order-item-option ref="orderItemOption" :options="selectedSubProduct.subProduct.options" :collapse="true"
      :isDeliverect="newCart.is_deliverect"
        :show-title="false" />
    </div>
    <div v-if="showValueOptions">
      <order-item-option ref="orderItemOption"
        :options="selectedValueSubOptions && selectedValueSubOptions.value ? selectedValueSubOptions.value.options : []"
        :collapse="true" :show-title="false"
        :isDeliverect="newCart.is_deliverect"
         />
    </div>
    <!---- Start Footer ---->
    <template slot="footer">
      <div class="w-100 d-flex justify-content-center pt-3">
        <n-button v-if="showSubProductOptions" :style="myTheme.customizeButton" type="primary"
          @click.native="addOptionsToMealDeal()" class="w-75">{{ $t("button.add_to_meal_deal") }}</n-button>

        <n-button v-else-if="showValueOptions" :style="myTheme.customizeButton" type="primary"
          @click.native="addOptionsToValue()" class="w-75">{{ $t("button.add_to_order") }}</n-button>
        <n-button v-else :style="myTheme.customizeButton" type="primary" @click.native="addOptionsToOrder()" class="w-75">
          <div class="media w-100">
            <p class="
                    media-body
                    mb-0
                    text-left text-white text-sm
                    font-weight-bolder
                  ">
              {{
                editMode ? $t("button.update_order") : $t("button.add_to_order")
              }}
            </p>
            <p class="mb-0 text-white text-sm font-weight-bolder">
              {{ getTotalPrice | currency(currentCurrency) }}
            </p>
          </div>
        </n-button>

      </div>
    </template>
    <!----End Footer ---->
  </modal>
</template>
<script>
import { mapActions} from "vuex";
import { FavouriteUnselected, FavouriteSelected } from "../svg";
import { OrderItemOption } from "../partial";

import {
  getMenuItemPrice,
  getMenuItemTotal,
  checkRequiredOptions,
  getOptionTotal,
  getMenuItemDieatriesIcons,
  checkIfAnyOptionIsSelected
} from "@/utilities/helper";
import { OPTION_TYPE } from "@/utilities/enums";

import {
  Button,
  Cards,
  RadioButton,
  FormTexterea,
  CheckboxButton,
  Alert,
  Modal,
} from "@/components";

export default {
  name: "order-modal",
  components: {
    [Button.name]: Button,
    Cards,
    Alert,
    Modal,
    [RadioButton.name]: RadioButton,
    [FormTexterea.name]: FormTexterea,
    [CheckboxButton.name]: CheckboxButton,
    FavouriteUnselected,
    FavouriteSelected,
    OrderItemOption,
  },
  props: {
    fromItem: Object,
    editMode: Boolean,
    index: Number,
    orderType: Number,
  },
  data() {
    return {
      getMenuItemDieatriesIcons,
      OPTION_TYPE,
      shown: false,
      isLoading: false,
      showAlert: false,
      msgAlert: "",
      showSubProductOptions: false,
      showValueOptions: false,
      selectedSubProduct: null,
      selectedValueSubOptions: null,
      getTotalPrice: 0,
    };
  },
  computed: {
    getItemPrice() {
      return getMenuItemPrice(this.fromItem, this.orderType);
    },
    getOptionTotal() {
      return (option) => {
        return getOptionTotal(option);
      };
    },
    isValueSelected() {
      return (option) => {
        const selected =
          option.type === OPTION_TYPE.checkbox
            ? option.selected
            : option.selected
              ? [option.selected]
              : [];
        return !!selected.length;
      };
    },
  },
  methods: {
    ...mapActions('userStore', ["addToFavorite", "deleteFavorite"]),
    decrease() {
      this.fromItem.quantity--;
    },
    increase() {
      if (this.fromItem.quantity > 999) return;
      this.fromItem.quantity++;
    },
    async addOptionsToOrder() {
      let missingOptions = false; // that will allow to add items without options
      if (this.fromItem.hasOptions) {
        missingOptions = await checkRequiredOptions(this.fromItem.options).catch(
          (msg) => {
            this.msgAlert = msg;
            this.showAlert = true;
            return true;
          }
        );
      }

      // check if the required sections are selected for teh meal deal
      let missingSubProduct = false
      if (this.fromItem.is_meal_deal) {
        missingSubProduct = await checkRequiredOptions(this.fromItem.sections).catch(msg => {
          this.msgAlert = msg;
          this.showAlert = true;
          return true;
        })
      }

      if (!missingOptions && !missingSubProduct) {
        this.showAlert = false;
        this.$root.$emit("PUSH_ITEM", {
          item: this.fromItem,
          openModal: false,
          editMode: this.editMode,
        });
      }
    },
    onItemDelete(_index) {
      this.$root.$emit("REMOVE_ITEM", _index);
    },
    openModal() {
      this.selectedSubProduct = null;
      this.showSubProductOptions = false;
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },
    onValueSelected(item) {
      if (!item.option.selected) {
        item.option.selected = [];
      }
      item.option.selected.push(item.value);
    },
    handleShowSubProductOptions(data) {
      this.selectedSubProduct = data;
      this.showSubProductOptions = true;
      this.showValueOptions = false;
      this.selectedValueSubOptions = null;
    },
    handleShowValueOptions(data) {
      this.selectedSubProduct = null;
      this.showSubProductOptions = false;
      this.showValueOptions = true;
      this.selectedValueSubOptions = data;
    },
    async addOptionsToMealDeal() {

      let missingOptions = false; // that will allow to add items without options
      if (this.selectedSubProduct.subProduct.hasOptions) {
        missingOptions = await checkRequiredOptions(
          this.selectedSubProduct.subProduct.options
        ).catch((msg) => {
          this.msgAlert = msg;
          this.showAlert = true;
          return true;
        });
      }

      if (!missingOptions) {
        this.showAlert = false;
        this.showSubProductOptions = false;

        this.$root.$emit("PUSH_MEAL_DEAL_OPTIONS", this.selectedSubProduct);
      }
    },
    async addOptionsToValue() {
      let missingOptions = false; // that will allow to add items without options
      if (this.selectedValueSubOptions?.value?.options?.length) {
        missingOptions = await checkRequiredOptions(
          this.selectedValueSubOptions.value.options
        ).catch((msg) => {
          this.msgAlert = msg;
          this.showAlert = true;
          return true;
        });
      }

      if (!missingOptions) {
        this.showAlert = false;
        this.$root.$emit("PUSH_VALUE_OPTIONS", this.selectedValueSubOptions.value);
        this.showValueOptions = false;
      }
    },
    async onBackClick(options, isMealDeal = true) {
      const anyValueIsSelected = await checkIfAnyOptionIsSelected(options);
      if (anyValueIsSelected) {
        const confirmOptions = {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "DISCARD CHOICES",
          cancelButtonText: "CONTINUE",
          customClass: "wtf-order-confirm",
          confirmButtonClass: "w-100 py-3 el-button--danger",
          cancelButtonClass: "w-100 py-3 el-button--primary mb-3",
          showClose: false,
          center: true,
          closeOnClickModal: false,
          type: "danger",
        };
        this.$confirm(
          `
          <p class='font-weight-bolder text-md mb-2'>You have not completed your option choices.</p>
          <p class="font-weight-normal text-md mb-2">if you wish to complete your selection click continue below, then click the</p>
          <p class='font-weight-bolder text-md mb-2'>${isMealDeal ? "Add to Meal Deal" : "Add to Order"}</p>
          <p class="font-weight-normal text-md mb-2">button when you are finished</p>
        
        `,
          "DISCARD CHOICES",
          confirmOptions
        )
          .then(() => {
            this.discardChanges({
              isSingle: this.showValueOptions ? this.selectedValueSubOptions.isSingle : this.selectedSubProduct.isSingle,
              item: this.showValueOptions ? this.selectedValueSubOptions.option : this.selectedSubProduct.section,
              subItems: this.showValueOptions ? this.selectedValueSubOptions.value : this.selectedSubProduct.subProduct,
            })
          })
          .catch(() => { });
      } else {
        this.discardChanges({
          isSingle: this.showValueOptions ? this.selectedValueSubOptions.isSingle : this.selectedSubProduct.isSingle,
          item: this.showValueOptions ? this.selectedValueSubOptions.option : this.selectedSubProduct.section,
          subItems: this.showValueOptions ? this.selectedValueSubOptions.value : this.selectedSubProduct.subProduct,
        })

      }
    },
    discardChanges(data) {
      // clear the parent selected value if the changes are discarded
      data.item.selected_items = []
      if (data.isSingle) {
        data.item.selected = null;
      } else {
        data.item.selected = data.item.selected.filter(x => x != data.subItems.id)
      }
      data.subItems.options.forEach(option => {
        option.selected_items = [];
        option.selected = option.type == "CHECKBOX" ? [] : null
      })

      this.clearSelectedItems()
    },
    clearSelectedItems() {
      this.showAlert = false
      this.showSubProductOptions = false
      this.showValueOptions = false
      this.selectedSubProduct = null
      this.selectedValueSubOptions = null
      this.msgAlert = ""
      
    }
  },
  watch: {
    fromItem: {
      deep: true,
      handler(newVal) {
        this.getTotalPrice = getMenuItemTotal(newVal, this.orderType);
        
      },
    },
  },
};
</script>
